export const CONNECTION_SCOPES = {
  PROJECT: "project",
  CONTAINERS: "containers",
  DATABASES: "databases",
  DISPLAY_GATEWAYS: "displaygateways",
  NODES: "nodes",
  SNOWFLAKES: "snowflakes",
  VIRTUAL_PRIVATE_NETWORK_GATEWAYS: "virtualprivatenetworkgateways",
  WORKSTATIONS: "workstations"
};

export const CONNECTION_PROTOCOLS = {
  TCP: "TCP",
  UDP: "UDP"
};

export const PUBLIC_CONNECTION_SCOPE_KEYS = [
  "PROJECT",
  "DISPLAY_GATEWAYS",
  "VIRTUAL_PRIVATE_NETWORK_GATEWAYS",
  "SNOWFLAKES"
];
